import React from 'react';

import Icon from './components/Icon';

const IconExpand = (props: any) => {
	return <Icon id="mpa-expand" handle={props.handle} {...props} />;
};

export default IconExpand;
